<script setup lang="ts">
import { useHead } from "@unhead/vue";
import { computed } from "vue";
import { RouterView } from "vue-router";
import { Toaster } from "vue-sonner";

import { useRedirection } from "@/composables/useRedirection";
import { useI18n } from "@/i18n";

import { useUser } from "./composables/api/useUser";
import { useCurrentTranslations } from "./composables/useCurrentTranslations";

import LoginView from "./views/LoginView.vue";
import SessionExpiredDialog from "@/components/dialogs/SessionExpiredDialog.vue";
import Footer from "@/components/sections/Footer.vue";

useI18n();

const { data: user } = useUser();
const { data: translations } = useCurrentTranslations();

useRedirection();

const headLink = computed(() => {
  if (user.value?.current_mechanic === "lactel") {
    return [
      {
        rel: "icon",
        href: "/lactel/images/lactel-club-favicon.png",
        type: "image/x-icon",
      },
    ];
  }

  if (user.value?.current_mechanic === "galbani") {
    return [
      {
        rel: "icon",
        href: "/favicon.png",
        type: "image/x-icon",
      },
    ];
  }
  return [];
});

const headTitle = computed(() => {
  if (user.value?.current_mechanic === "lactel") {
    return "Lactel club";
  }
  if (user.value?.current_mechanic === "galbani") {
    return "Galbani x Top Chef";
  }
  return "";
});

const headMeta = computed(() => {
  if (user.value?.current_mechanic === "lactel") {
    return [
      {
        property: "og:title",
        content: "Programme de récompenses lactel",
      },
      {
        property: "og:site_name",
        content: "Lactel club",
      },
      {
        property: "og:description",
        content: "Transformez vos courses Lactel en cadeaux exclusifs et en bons de réduction.",
      },
      {
        property: "og:type",
        content: "website",
      },
    ];
  }
  if (user.value?.current_mechanic === "galbani") {
    return [
      {
        property: "og:title",
        content: "Programme de récompenses Galbani x Top Chef",
      },
      {
        property: "og:site_name",
        content: "Galbani x Top Chef",
      },
      {
        property: "og:description",
        content:
          "Transformez vos courses Galbani en cadeaux exclusifs Top Chef et en bons de réduction.",
      },
      {
        property: "og:type",
        content: "website",
      },
    ];
  }
  return [];
});

useHead({
  title: headTitle,
  link: headLink,
  meta: headMeta,
});
</script>

<template>
  <template v-if="user && translations.length">
    <RouterView />

    <Footer />

    <Toaster :closeButton="true" />

    <SessionExpiredDialog />
  </template>

  <template v-else>
    <LoginView />
  </template>
</template>
